import { LatLngLiteral } from 'src/common/components/Search/typesGoogle';

/**
 * The `SHOULD_BE_VALIDATED` value should always be true. Disabling it will remove form errors,
 * Validation will be temporarily disabled during saving (`SHOULD_BE_VALIDATED = false`) and
 * re-enabled afterwards to allow submission.
 * If the user attempts to publish, SHOULD_BE_VALIDATED will be kept true to ensure
 * validation runs fully before publishing.
 */
export const SHOULD_BE_VALIDATED = 'SHOULD_BE_VALIDATED';
export const ACTIVE_FIELD = 'active';
export const PHOTOS_FIELD = 'photos';

export const LAT_LON_FIELD = 'latLon';
export const AUTOCOMPLETE_INPUT = 'autocompleteInput';
export const CAPTAIN_OPTIONS = 'captain_options';
export const SNOOZE_END_DATE = 'snooze_end_date';
export const SNOOZE_START_DATE = 'snooze_start_date';
export const SNOOZE_REASON = 'snooze_reason';

export const NUMBER_ENGINES_FIELD = 'number_engines';
export const ENGINE_HORSEPOWER_FIELD = 'engine_horsepower';
export const ENGINE_BRAND_FIELD = 'engine_brand';
export const ENGINE_MODEL_FIELD = 'engine_model';
export const YEAR_FIELD = 'year';
export const MAKE_FIELD = 'make';
export const MODEL_FIELD = 'model';
export const MAX_LENGTH_FIELD = 'max_length';
export const TAGS_FIELD = 'tags';
export const FEATURES_FIELD = 'features';
export const LATITUDE = 'latitude';
export const LONGITUDE = 'longitude';
export const HEADLINE = 'headline';
export const SHORTNAME = 'shortname';
export const DESCRIPTION = 'description';
export const ADDRESS = 'address';
export const CITY = 'city';
export const STATE = 'state';
export const ZIP = 'zip';
export const COUNTRY = 'country';
export const CAPACITY_FIELD = 'capacity';
export const PRIMARY_CATEGORY = 'primaryCategory';

export const ZOOM_LEVEL = 15;
export const WORLD_ZOOM_LEVEL = 2;
export const HEADLINE_MAX_LENGTH = 80;
export const HEADLINE_MIN_LENGTH = 20;
export const SHORTNAME_MAX_LENGTH = 32;
export const DESCRIPTION_MAX_LENGTH = 10000;
export const MINIMUM_LIMIT = 1; // Minimum value for hours, multiday, and capacity
export const MAXIMUM_HOURS_LIMIT = 23;
export const MAXIMUM_HOURS_DEFAULT = 12;
export const MAXIMUM_MULTIDAY_LIMIT = 365;
export const MAXIMUM_MULTIDAY_DEFAULT = 30;
export const MAXIMUM_CAPACITY_LIMIT = 1000;

// Photo Panel
export const MINIMUM_PHOTOS = 3;
export const MAXIMUM_PHOTOS = 50;

// Pricing fields
export const CANCELATION_ANTICIPATION_FIELD = 'cancelation_anticipation';
export const CANCELATION_REFUND_FIELD = 'cancelation_refund';
export const CANCELATION_TERMS_FIELD = 'cancelation_terms';
export const DEPOSIT_FIELD = 'deposit';
export const MAXIMUM_MULTIDAY_FIELD = 'maximum_multiday';
export const MAXIMUM_HOURS_FIELD = 'maximum_hours';

export const worldMapCoordinates: LatLngLiteral = { lat: 28.7465, lng: 10.4629 };

export const COUNTRY_USA = 'United States';
// Boat Location Modal Steps
export const STEP_1_STREET_ADDRESS = 'street-address';
export const STEP_2_DEPARTURE_LOCATION = 'departure-location';
export const STEP_3_BOARDING_POINT = 'boarding-point';

// Boat Locations Form
export const LOCATION_ID = 'id';
export const BOAT_LOCATIONS_ERROR = 'boat_locations_error';
export const STREET_ADDRESS_FORM = 'street-address-form';
export const DEPARTURE_LOCATION_FORM = 'departure-location-form';
export const BOARDING_POINT_FORM = 'boarding-point-form';
export const ADDRESS_AUTOCOMPLETE = 'autocomplete_text';
export const LOCATION_TITLE = 'title';
export const STREET_ADDRESS = 'street_address';
export const STREET_CITY = 'street_city';
export const STREET_STATE = 'street_state';
export const STREET_COUNTRY = 'street_country';
export const STREET_ZIP = 'street_zip';
export const STREET_LATITUDE = 'street_latitude';
export const STREET_LONGITUDE = 'street_longitude';
export const IS_VALID_STREET_ADDRESS = 'is_valid_street_address';
export const DEPARTURE_ADDRESS = 'departure_address';
export const DEPARTURE_ADDRESS_TEXT = 'departure_address_text';
export const DEPARTURE_CITY = 'departure_city';
export const DEPARTURE_STATE = 'departure_state';
export const DEPARTURE_COUNTRY = 'departure_country';
export const DEPARTURE_ZIP = 'departure_zip';
export const DEPARTURE_LATITUDE = 'departure_latitude';
export const DEPARTURE_LONGITUDE = 'departure_longitude';
export const SAME_ADDRESS = 'same_address';
export const ARRIVAL_INSTRUCTIONS = 'arrival_instructions';
